// src/pages/ExitoSalaQr.js
import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { CheckCircle as CheckIcon } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';

const ExitoSalaQr = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { pacienteQr, sala, idCliente, nombrePaciente } = location.state || {};

  if (!pacienteQr || !sala || !idCliente) {
    return <Typography>Error: datos incompletos</Typography>;
  }

  const handleGoToClient = () => {
    navigate(`/clientes/${idCliente}`);
  };

  return (
    <Box sx={{ p: 3, pt: 8, display: 'flex', justifyContent: 'center', minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      <Paper elevation={3} sx={{ p: 5, textAlign: 'center', maxWidth: 500, borderRadius: 2 }}>
        
        <Box sx={{ mb: 3 }}>
          <CheckIcon sx={{ fontSize: 120, color: '#4caf50' }} />
        </Box>

        <Typography variant="h5" color="success.main" gutterBottom>
          ¡Asignación Exitosa!
        </Typography>

        <Typography variant="body1" sx={{ mb: 1 }}>
          <strong>{nombrePaciente || pacienteQr}</strong>
        </Typography>

        <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
          Código: {pacienteQr}
        </Typography>

        <Typography variant="body1" sx={{ mb: 3 }}>
          fue asignado con éxito a la
        </Typography>

        <Typography variant="h6" color="primary" sx={{ mb: 4, fontWeight: 'bold' }}>
          {sala}
        </Typography>

        <Button
          variant="contained"
          color="primary"
          onClick={handleGoToClient}
          size="large"
        >
          Ver Ficha del Cliente
        </Button>
      </Paper>
    </Box>
  );
};

export default ExitoSalaQr;